import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

export interface IConfirmationModalProps {
  onClose: () => void;
  title: string;
}

export const ConfirmationModal: React.FC<IConfirmationModalProps> = (props) => {
  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={() => props.onClose()}
        >
          <div className="min-h-screen px-4 text-center">
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  {props.title}
                </Dialog.Title>

                {props.children}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export interface IConfirmationContentContainerProps {}

/**content container you should use when building confirmation content */
export const ConfirmationContentContainer: React.FC<IConfirmationContentContainerProps> =
  (props) => {
    return <div className="mt-2">{props.children}</div>;
  };

export interface IConfirmationFooterContainerProps {}

/**footer container you should use when building confirmation content */
export const ConfirmationFooterContainer: React.FC<IConfirmationFooterContainerProps> =
  (props) => {
    return (
      <div className="mt-4 flex flex-row-reverse space-x-reverse space-x-2">
        {props.children}
      </div>
    );
  };
